import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigurationKey = 'iframe';

interface IframeDataProps {
    html: string;
    dataId?: string;
}

export interface IframeThemeProps {
    backgroundColor: string;
}

type IframeComponentProps = IframeDataProps & MandatoryAdditionalStyle;
export type IframeProps = IframeDataProps & MandatoryAdditionalStyle;


const createIframeWrapperStyle = (backgroundColor: string) => StyleSheet.create({
  style: {
    backgroundColor,
  },
});

export const Gfycat: React.FunctionComponent<IframeComponentProps> = props => {
  const { html, additionalStyle, dataId } = props;
  const { backgroundColor } = useTheme<IframeThemeProps>(componentConfigurationKey);
  const iframeWrapperStyle = createIframeWrapperStyle(backgroundColor);
  return (
    <ErrorBoundary>
      <div className={css(additionalStyle.style)}>
        {/* eslint-disable-next-line react/no-danger */}
        <figure data-id={dataId} className={css(iframeWrapperStyle.style)} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </ErrorBoundary>
  );
};
